/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --star-size: 20px;
}

:host(:state(disabled)) .stars {
  pointer-events: none;
}

[input] {
  position: relative;
}

[name='star'] {
  --color: var(--nve-ref-color-yellow-amber-900);
}

[name='star-half'] {
  --color: var(--nve-ref-color-yellow-amber-900);
  --stroke-color: var(--nve-ref-border-color-emphasis);
}

[name='star-stroke'] {
  --color: var(--nve-ref-border-color-emphasis);
}

nve-icon {
  --width: var(--star-size);
  --height: var(--star-size);
}

.stars {
  display: flex;
  gap: var(--nve-ref-space-xxxs);
  height: var(--nve-ref-size-800);
}

::slotted(input) {
  opacity: 0;
  position: absolute;
  inset: 0;
  z-index: -1;
  margin: 0;
}
